/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, useEffect, useState } from 'react';

import './scalableImage.scss';

export const scalableImageWidths = ["1920", "1600", "1440", "1366", "1024", "960", "768", "640", "480", "320"];

const STORAGE_BASE_URL = "https://ozon-prod-storage-bucket.s3.amazonaws.com/public/uploads/";
const IMAGEKIT_BASE_URL = "https://ik.imagekit.io/ozon/";

interface ScalableImageProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>{
	src?: string;
	desktopWidth?:number;
	mobileWidth?:number;
	fetchpriority?: 'high' | 'low' | 'auto';
}
const ScalableImage: FC<ScalableImageProps> = ({
	src,
	desktopWidth = 100,
	mobileWidth,
	...props
}) => {

	const [srcSet, setSrcSet] = useState<string>("");

	useEffect(() => {
		if(src === undefined) return;

		let imagekitSrc = "";
		if(src.startsWith(STORAGE_BASE_URL)) {
			imagekitSrc = `${IMAGEKIT_BASE_URL}${src.split(STORAGE_BASE_URL)[1]}`;
		} else {
			imagekitSrc = src;
		}

		const scales = scalableImageWidths.map((width) =>
			`${imagekitSrc}?tr=w-${width} ${width}w`
		);
		setSrcSet(scales.join(", "));
	}, [src]);

	return srcSet.length ? (
		<img src= {src} {...props}  srcSet={srcSet} sizes={`(max-width: 600px) ${mobileWidth??desktopWidth}vw, ${desktopWidth}vw`}/>
	):null;
};

export default ScalableImage;